<template>
    <div class="submit-dialog-container">
        <div class="submit-dialog">
            <div class="submit-dialog-header">
                <h2>提交需求</h2>
                <p>提交后官方顾问会尽快与您联系</p>
                <img
                    src="../assets/close.png"
                    @click="onClose"
                />
            </div>
            <div
                v-if="!isSuccess"
                class="submit-dialog-content"
            >
                <div class="form-item">
                    <div class="form-item-label">需求服务</div>
                    <div class="form-item-content form-content-text">代理记账服务</div>
                </div>
                <div class="form-item">
                    <div class="form-item-label">需求地区</div>
                    <div class="form-item-content">
                        <el-select
                            v-model="formData.area"
                            :filterable="true"
                            size="large"
                        >
                            <el-option-group
                                v-for="group in regionDatasource"
                                :key="group.label"
                                :label="group.label"
                            >
                                <el-option
                                    v-for="item in group.options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                ></el-option>
                            </el-option-group>
                        </el-select>
                    </div>
                </div>
                <div
                    class="form-item"
                    style="margin-bottom: -15px"
                >
                    <div class="form-item-label">需求备注</div>
                    <div class="form-item-content">
                        <textarea
                            v-model="formData.description"
                            :rows="3"
                            :maxlength="255"
                            placeholder="请简单输入您的需求描述"
                        />
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-item-label">手机号</div>
                    <div class="form-item-content">
                        <input
                            v-model="formData.phone"
                            :maxlength="11"
                            placeholder="仅用于专家与您联系，请放心填写"
                            data-track-value="landSubmitPhone"
                            data-track-name="需求填写手机号"
                        />
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-item-label">验证码</div>
                    <div class="form-item-content">
                        <input
                            v-model="formData.smsCode"
                            :maxlength="6"
                            class="verify-input"
                            placeholder="请输入验证码"
                            data-track-value="landSubmitVerifyCode"
                            data-track-name="需求填写验证码"
                        />
                        <a
                            :class="['verify-btn', verifyBtnDisabled ? 'disable-verify-btn' : '']"
                            @click="getVerifyCode"
                        >{{ verifyText }}</a>
                    </div>
                </div>
                <div class="check-content">
                    <input
                        v-model="checkRule"
                        type="checkbox"
                        name="checkRule"
                    />
                    <span class="check-text">
                        我已阅读并同意
                        <a
                            href="https://cloud.baidu.com/doc/CBS/s/8kno0p6fi"
                            target="_blank"
                        >《百度智能云代理记账用户服务协议》</a>
                    </span>
                </div>
                <a
                    :class="['submit-btn', submitBtnDisabled ? 'disable-btn' : '']"
                    @click="onSubmit"
                >
                    确认提交
                </a>
            </div>
            <div
                v-else
                class="submit-dialog-content submit-success"
            >
                <img src="../assets/submit_success.png" />
                <p>需求提交成功，客户经理会尽快与您联系</p>
                <p>(窗口将会在{{ count }}s后自动关闭)</p>
            </div>
        </div>
    </div>
</template>

<script>
import client from '../common/client.js';
import {isLogin, isOnline} from '../util/helper';
import {store} from '../util/store';
import {Notification} from 'element-ui';

export default {
    props: {
        name: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            formData: {
                bizType: 'BKP',
                phone: '',
                smsCode: '',
                area: 110100,
                description: ''
            },
            // 获取验证码倒计时
            codeCountDown: 60,
            // 是否正在提交
            submitting: false,
            codeTimer: null,
            isSuccess: false,
            checkRule: true,
            timeLoading: false,
            errorMessage: '',
            loading: false,
            count: 5,
            hasLogin: false,
            loginLink: 'https://login.bce.baidu.com/',
            requestFinished: false
        };
    },
    computed: {
        submitBtnDisabled() {
            const {phone, smsCode} = this.formData;
            return !(
                /^1\d{10}$/.test(phone) &&
                /^\d{6}$/.test(smsCode) &&
                this.checkRule &&
                !this.submitting
            );
        },
        verifyBtnDisabled() {
            const {phone} = this.formData;
            return !(/^1\d{10}$/.test(phone) && this.codeCountDown === 60);
        },
        regionDatasource() {
            return store.state.regionDatasource;
        },
        verifyText() {
            return this.codeCountDown === 60 ? '获取验证码' : `倒计时${this.codeCountDown}秒`;
        }
    },
    mounted() {
        isLogin()
            .then(res => {
                this.requestFinished = true;
                this.hasLogin = res && res.result && res.result.hasLogin;
            })
            .catch(() => {
                this.requestFinished = true;
                this.hasLogin = false;
            });
        this.getLoginLink();
    },
    beforeDestroy() {
        this.clearCodeTimer();
    },
    methods: {
        getVerifyCode() {
            if (this.verifyBtnDisabled) {
                return;
            }

            this.codeCountDown -= 1;
            this.codeTimer = setInterval(() => {
                if (this.codeCountDown <= 1) {
                    this.clearCodeTimer();
                    return;
                }
                this.codeCountDown -= 1;
            }, 1000);

            client
                .getBkpVerifyCode({
                    phone: this.formData.phone
                })
                .then(res => {
                    if (res.data && res.data.success === false) {
                        Notification.error({
                            title: '失败',
                            message: '验证码发送失败，请稍后再试',
                            offset: 100,
                            duration: 2000
                        });
                    }
                })
                .catch(() => {
                    Notification.error({
                        title: '失败',
                        message: '接口调用失败',
                        offset: 100,
                        duration: 2000
                    });
                    this.clearCodeTimer();
                });
        },
        clearCodeTimer() {
            clearInterval(this.codeTimer);
            this.codeTimer = null;
            this.codeCountDown = 60;
        },
        onSubmit() {
            if (this.submitBtnDisabled) {
                return;
            }

            this.submitting = true;

            client
                .submitBkpDemand({
                    ...this.formData,
                    hasLogin: this.hasLogin
                })
                .then(res => {
                    const response = res.data;
                    this.submitting = false;
                    if (response && response.demandId) {
                        this.onClose();
                        Notification.success({
                            title: '提交成功',
                            message: '需求提交成功，客户经理会尽快与您联系',
                            offset: 100,
                            duration: 2000
                        });
                    } else if (
                        response &&
                        response.message &&
                        response.message.global &&
                        response.message.global === 'Verification code is invalid.'
                    ) {
                        Notification.error({
                            title: '失败',
                            message: '验证码填写错误',
                            offset: 100,
                            duration: 2000
                        });
                    } else {
                        Notification.error({
                            title: '失败',
                            message: '需求提交失败',
                            offset: 100,
                            duration: 2000
                        });
                    }
                })
                .catch(() => {
                    this.submitting = false;
                    Notification.error({
                        title: '失败',
                        message: '接口调用失败',
                        offset: 100,
                        duration: 2000
                    });
                });
        },
        onClose() {
            this.$emit('close');
        },
        getLoginLink() {
            const targetUrl = isOnline
                ? 'https://login.bce.baidu.com/?redirect='
                : 'https://login.bcetest.baidu.com/?redirect=';
            this.loginLink =
                targetUrl +
                encodeURIComponent(window.location.origin + window.location.pathname + '?from=require') +
                '#/bkp/detail';
        }
    }
};
</script>

<style lang="less">
.submit-dialog-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 10000;

    .submit-dialog {
        width: 545px;
        background: #ffffff;
    }
    .submit-dialog-header {
        height: 56px;
        background: linear-gradient(232deg, #459bff 0%, #006cff 100%);
        padding-left: 33px;
        h2 {
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            line-height: 22px;
            color: #ffffff;
            display: inline-block;
            padding-top: 17px;
        }
        p {
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 17px;
            color: #ffffff;
            display: inline-block;
            padding-top: 22px;
            padding-left: 10px;
        }
        img {
            width: 15px;
            height: 15px;
            float: right;
            margin: 20px;
            cursor: pointer;
        }
    }
    .submit-dialog-content {
        padding-top: 16px;
        height: 480px;
        position: relative;
        color: #ff8002;
    }
    .form-item {
        display: flex;
        align-items: flex-start;
        margin: 16px auto;
        width: 400px;
        .form-item-label {
            height: 40px;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 40px;
            color: #191c3d;
            margin-right: 16px;
            width: 65px;
            white-space: nowrap;
        }
        .form-content-text {
            position: relative;
            left: -10px;
        }
        .form-item-content {
            position: relative;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 40px;
            color: #191c3d;
            input {
                height: 40px;
                background: #ffffff;
                border: 1px solid #e0e0e0;
                padding: 0 10px;
                font-size: 14px;
                font-family: PingFang SC;
                font-weight: 400;
                line-height: 20px;
                color: #191c3d;
                width: 330px;
                outline: none;
            }
            textarea {
                background: #ffffff;
                border: 1px solid #e0e0e0;
                padding: 10px;
                font-size: 14px;
                font-family: PingFang SC;
                font-weight: 400;
                line-height: 20px;
                color: #191c3d;
                width: 330px;
                outline: none;
                resize: none;
                position: relative;
                left: -2px;
            }
            .verify-input {
                padding-right: 90px;
            }
            .verify-btn {
                position: absolute;
                right: 10px;
                top: 10px;
                color: #d82929;
                font-size: 14px;
                font-family: PingFang SC;
                font-weight: 400;
                line-height: 20px;
                cursor: pointer;
                user-select: none;
            }

            .disable-verify-btn {
                color: #999;
                cursor: not-allowed;
            }

            .el-input__inner {
                border-radius: 0;
                position: relative;
                left: -2px;
            }

            .el-input.is-focus .el-input__inner {
                border-color: #e0e0e0;
            }
        }
    }
    .submit-btn {
        width: 329px;
        height: 38px;
        background: #2468f2;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        line-height: 38px;
        color: #ffffff;
        display: block;
        text-align: center;
        margin: 20px auto 0;
        cursor: pointer;
        position: relative;
    }
    .check-content {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 16px;
        input {
            margin-right: 4px;
        }
        .check-text {
            height: 20px;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 20px;
            color: #191c3d;
            opacity: 0.5;
            a {
                text-decoration: none;
            }
        }
    }
    .submit-success {
        padding-top: 100px;
        img {
            width: 50px;
            height: 50px;
            display: block;
            margin: 0 auto 25px;
        }
        p {
            height: 22px;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 22px;
            color: #191c3d;
            opacity: 0.8;
            text-align: center;
        }
    }
    .disable-btn {
        color: #aaa;
        background-color: #f5f5f5;
        cursor: not-allowed;
    }
    .error-tip {
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #ea1818;
        text-align: center;
        position: absolute;
        bottom: -34px;
        left: 0;
        width: 329px;
    }
    .login-tip {
        color: #ff8002;
        a {
            text-decoration: none;
            color: #108cee;
        }
    }
}

.el-notification {
    z-index: 100002 !important;
}

.el-select-dropdown {
    z-index: 100002 !important;
}
</style>
